import React, { useEffect, useState } from 'react';
import './TableOfContents.css';

const slugify = (text = '') =>
  text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

const TableOfContents = ({ title = 'On this page', minLevel = 2, maxLevel = 3 }) => {
  const [headings, setHeadings] = useState([]);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const root = document.querySelector('[data-article-content]') || document.querySelector('main') || document.body;
    if (!root) return;

    const selectors = [];
    for (let level = minLevel; level <= maxLevel; level += 1) {
      selectors.push(`h${level}`);
    }

    const nodes = root.querySelectorAll(selectors.join(','));
    const collected = Array.from(nodes).map((node) => {
      let id = node.getAttribute('id');
      if (!id) {
        id = slugify(node.textContent);
        node.setAttribute('id', id);
      }
      return {
        id,
        text: node.textContent,
        level: Number(node.tagName.replace('H', '')),
      };
    });

    setHeadings(collected);
  }, [minLevel, maxLevel]);

  if (!headings.length) return null;

  return (
    <nav className="toc" aria-label="Table of contents">
      <h3>{title}</h3>
      <ul>
        {headings.map((heading) => (
          <li key={heading.id} className={`toc__item toc__item--level-${heading.level}`}>
            <a href={`#${heading.id}`}>{heading.text}</a>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default TableOfContents;
